const disabledClicks = [
  'menusettings',
  'menufireDept',
  'menuwound',
  'menupain',
  'menubreathing',
  'menupoison',
  'menuqrScan',
  'menunetwork',
  'menubelongingsEmergency',
  'menupast',
  'dependantsmessaging',
  'dependantsparentalControl',
  'dependantsdelegateChild',
  'dependantsedit',
  'papersManage',
  'valuablesManage',
  'qrManage',
  'qrInvite',
  'btManage',
];

export default disabledClicks;
